/**
 * toc.js — mục lục bài viết: sinh từ các h2 trong [data-toc-source], tô mục đang đọc.
 *
 * Markup cần:
 *   <nav class="toc" data-toc hidden><p class="toc__title">Trong bài này</p></nav>
 *   <div class="entry-content" data-toc-source> … the_content() … </div>
 * Tuỳ chọn (trang chi tiết sản phẩm):
 *   [data-toc-source][data-toc-headings="h3"]  lấy cấp heading khác h2 — ở đó h2 là tiêu đề khối
 *   [data-toc][data-toc-offset="56"]            px che thêm dưới header (hàng tab dính) để vạch
 *                                               "đang đọc" không nằm khuất sau hàng tab
 *
 * Lấy heading thẳng từ nội dung nên trên WordPress không cần plugin hay walker: giữ
 * hai thuộc tính data-* ở single.php là chạy. Dưới 2 thẻ h2 thì mục lục không có giá
 * trị — khung giữ nguyên `hidden`. Không có JS thì khung cũng ẩn (hidden sẵn trong HTML).
 *
 * Id của heading sinh từ chữ (bỏ dấu tiếng Việt): "Vì sao thịt nướng…" → #vi-sao-thit-nuong…
 * để link chia sẻ tới một mục vẫn đọc được. Heading đã có id (editor gán) thì giữ nguyên.
 * Mục đang đọc được đánh dấu bằng .is-active + aria-current="location".
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var container = document.querySelector('[data-toc]');
    var source = document.querySelector('[data-toc-source]');
    if (!container || !source) return;

    var headings = [].slice.call(source.querySelectorAll(source.getAttribute('data-toc-headings') || 'h2'));
    var extraOffset = parseInt(container.getAttribute('data-toc-offset'), 10) || 0;
    if (headings.length < 2) return;

    var used = {};

    function slugify(text, index) {
        var slug = text.toLowerCase();
        // normalize() tách dấu khỏi chữ cái để regex bỏ đi; "đ" không tách được nên đổi tay
        if (slug.normalize) slug = slug.normalize('NFD');
        slug = slug
            .replace(/[̀-ͯ]/g, '')
            .replace(/đ/g, 'd')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '')
            .slice(0, 60);
        if (!slug) slug = 'muc-' + (index + 1);
        // Hai heading trùng chữ thì thêm hậu tố để id không đụng nhau
        while (used[slug] || document.getElementById(slug)) slug += '-' + (index + 1);
        used[slug] = true;
        return slug;
    }

    var list = document.createElement('ol');
    list.className = 'toc__list';

    headings.forEach(function (heading, index) {
        if (!heading.id) heading.id = slugify(heading.textContent.trim(), index);

        var item = document.createElement('li');
        var link = document.createElement('a');
        link.className = 'toc__link';
        link.href = '#' + heading.id;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        list.appendChild(item);
    });

    container.appendChild(list);
    container.hidden = false;

    var links = [].slice.call(list.querySelectorAll('.toc__link'));
    var current = null;
    var ticking = false;

    // Vạch "đang đọc" nằm ngay dưới header dính (--header-height do navigation.js đo)
    function headerOffset() {
        var value = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
        return (isNaN(value) ? 190 : value) + extraOffset + 40;
    }

    function updateActive() {
        var offset = headerOffset();
        var active = headings[0];

        headings.forEach(function (heading) {
            if (heading.getBoundingClientRect().top <= offset) active = heading;
        });

        if (active === current) return;
        current = active;

        links.forEach(function (link) {
            var on = link.getAttribute('href') === '#' + active.id;
            link.classList.toggle('is-active', on);
            if (on) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
        });
    }

    window.addEventListener(
        'scroll',
        function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () {
                updateActive();
                ticking = false;
            });
        },
        { passive: true }
    );

    updateActive();
})();
